const homeNp = {
  hero: {
    title: 'ग्रामीण बजारमा स्वागत छ',
    subtitle: 'तपाईंका लागि ताजा, स्थानीय र विश्वसनीय सामान',
  },
  search: {
    placeholderDefault: 'के खोज्दै हुनुहुन्छ?',
    typewriterPlaceholders: [
      'ताजा तरकारी',
      'फलफूल',
      'दैनिक किराना',
      'औषधि',
      'इलेक्ट्रोनिक्स'
    ]
  },
  partners: {
    heading: 'हाम्रा साझेदार',
    subheading: 'विश्वसनीय ब्रान्ड र संस्थाहरूसँग साझेदारी'
  }
};

export default homeNp;


